
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Was überraschen mag: In der Nacht läuft unser Körper auf Hochtouren. Schlaf ist eigentlich nur ein anderer Wachzustand. So verbraucht der Körper im Schlaf fast genauso viel Energie wie in Wachphasen. In der Antike nahm man an, dass Schlaf einfach der inaktive Zustand des Menschen ist. `}<M mdxType="M">{`Mittlerweile wissen wir, dass Schlaf ein äusserst aktiver Prozess ist.`}</M>{` Schlaf ist eine Art Bewusstseinszustand, bei dem manche unserer Sinne aber nur reduziert funktionieren. Man kann im Schlaf zum Beispiel hören und riechen, aber man ist sich dessen nicht bewusst.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;